
import * as _ from 'lodash';
import React, { useState } from 'react';
import { Spinner, Col, Row, Button } from 'react-bootstrap';

import style from './order-summary.module.scss';

import {formatDate, formatDateTime, toCurrency} from '../../../../helpr/helper';
import numToWords from '../../../../helpr/numToWords';
import { getSessionId } from '../../../../helpr/authHelper';
import SecurityService from '../../../../services/security-service';
import { bankListMap, modeOfPaymentsMap, securityRegistrationMap, idTypesMap, investorCategoryMap, modeOfCollectionOfInterestMap, deliveryModesMap } from '../../../../helpr/orderFormData';


const OrderSummary = ({session, orderInfo, nextStep, setPageState, setErrorModalShow}) => {
  const securityService = new SecurityService(true);
  const [ isFormSubmitted, setIsFormSubmitted ] = useState(false);
  const submitHandler = () => {
    async function service (orderInfo) {
      setIsFormSubmitted(true);
      let requestPayload = _.cloneDeep(orderInfo);
      requestPayload['contactNumbers']  = {
        'telephoneNumbers' : requestPayload['contactNumbers']['telephoneNumbers'].map((data, index)=>{
          return data['number'];
        }),
        'faxNumbers' : requestPayload['contactNumbers']['faxNumbers'].map((data, index)=>{
          return data['number'];
        })
      }
      try {
        await securityService.createOrder(session['securityId'], getSessionId(), requestPayload);
        nextStep();
      } catch(err) {
        if(err.response){
          if(err.response.status === 403){
            setPageState(1);
          } else {
            // Set Page State to Session Expired
            console.log(err.response);
            setErrorModalShow(true);
          }
        } else {
          // Set Page State to Session Expired
          console.log(err.response);
          setErrorModalShow(true);
        }
        setIsFormSubmitted(false);
      }
    }
    if( !isFormSubmitted ){ service(orderInfo) };
  }

  const renderHeaderValue = (header, value) => {
    return (
      <Row className={style['info']}>
        <Col className={style['info-header']}>
          <div className={style['header']}>
            { header }
          </div>
        </Col>
        <Col className={style['info-value']}>
          <div className={`${style['header']} ${style['wrap']}`}>
            { value }
          </div>
        </Col>
      </Row>
    )
  }

  const renderModeOfPayment = (mode) => {
    if(mode === 'BANK_CHECK'){
      return (
        <>
          { renderHeaderValue('Drawee Bank', bankListMap(orderInfo['modeOfPayment'].bank)) }
          { renderHeaderValue('Check #', orderInfo['modeOfPayment'].checkNumber) }
        </>
      )
    }
    if(mode === 'DIRECT_DEBIT'){
      return (
        <>
          { renderHeaderValue('Debit Account Number', orderInfo['modeOfPayment'].debitAccountNumber) }
          { renderHeaderValue('Bank Branch', bankListMap(orderInfo['modeOfPayment'].bank)) }
        </>
      )
    }
  }
  console.log(orderInfo);
  return (
    <div className={style['order-summary']}>
      <Row>
        <Col>
            <div className={style['order-summary-panel']}>
              <div className={style['order-summary-panel-header']}>
                RESERVATION SUMMARY
              </div>
              <div className={style['order-summary-panel-body']}>
                <div className={style['slice']}>
                  { renderHeaderValue('Security Name', session['securityName']) }
                  { renderHeaderValue('Issuer', session['securityIssuer']) }
                  { renderHeaderValue('Amount', toCurrency(orderInfo['purchaseAmount'])) }
                </div>
                <div className={style['slice']}>
                  { orderInfo['investorCategory'] == 'INDV'?
                    renderHeaderValue('Account Name(s)', orderInfo['accountNames'])
                  : renderHeaderValue('Account Name(s)', orderInfo['primaryApplicant']) }
                  { renderHeaderValue('Primary Contact Person', orderInfo['primaryContactPersonName']) }
                  { renderHeaderValue('Relationship to Primary Applicant', orderInfo['primaryContactPerson']['relation']) }
                  { renderHeaderValue('Investor Category', investorCategoryMap(orderInfo['investorCategory'])) }
                  { renderHeaderValue('Nationality', orderInfo['nationality']) }
                  { renderHeaderValue('Place of Residence', orderInfo['place']) }
                  { renderHeaderValue('Permanent Address', orderInfo['mailingAddress']) }
                  { renderHeaderValue('Present Address', orderInfo['presentMailingAddress']) }
                  { (orderInfo['investorCategory'] === 'INDV' && orderInfo['applicantList']['applicants'].length > 1)
                    ? renderHeaderValue('Date of Birth', orderInfo['applicantList']['applicants'].map(a => formatDate(a.date_of_birth)).join(', '))
                    : renderHeaderValue('Date of Incorporation', orderInfo['dateOfBirthOrIncorporation'])
                  }
                  { (orderInfo['investorCategory'] === 'INDV' && orderInfo['applicantList']['applicants'].length > 1)
                    ? renderHeaderValue('Email Address', orderInfo['applicantList']['applicants'].map(a => a.email).join(', '))
                    : renderHeaderValue('Email Address', orderInfo['investorEmail'])
                  }
                  { renderHeaderValue((orderInfo['investorCategory'] === 'INDV'?
                    'Place of Birth' : 'Place of Incorporation'), orderInfo['placeOfBirthOrIncorporation']) }
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue('ID Type', idTypesMap(orderInfo['idType'])) }
                  { renderHeaderValue('ID Number', orderInfo['idNumber']) }
                  { renderHeaderValue('Tax Status', orderInfo['taxStatus']) }
                  { renderHeaderValue('Reservation Date', formatDateTime(orderInfo['orderDate']))}
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue('Contact Numbers',
                    orderInfo['contactNumbers']['telephoneNumbers'].map((data, index)=>{
                      if( index !== 0 ){ return ', ' + data['number']}
                      return data['number']
                    })) }
                  { renderHeaderValue('FAX Numbers',
                    orderInfo['contactNumbers']['faxNumbers'].map((data, index)=>{
                      if( index !== 0 ){ return ', ' + data['number']}
                      return data['number']
                    })) }
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue((orderInfo['investorCategory'] === 'INDV'?
                    'Nature of Work/Business' : 'Principal Business of the Corporation'), orderInfo['businessDetails'].nature) }
                  { renderHeaderValue('Parent Company', orderInfo['businessDetails'].parentCompany) }
                  { renderHeaderValue((orderInfo['investorCategory'] === 'INDV'?
                    'Name of Employer' : 'Name of Business'), orderInfo['businessDetails'].name) }
                  { renderHeaderValue('Sources of Income', orderInfo['businessDetails'].sourcesOfIncome.join(', ')) }
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue('Mode of Payment', modeOfPaymentsMap(orderInfo['modeOfPayment'].option)) }
                  { renderModeOfPayment(orderInfo['modeOfPayment'].option) }
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue('Mode of Collection of Interest and Principal Payments', modeOfCollectionOfInterestMap(orderInfo['modeOfCollectionOfInterest'])) }
                  { renderHeaderValue('Settlement Bank Code', bankListMap(orderInfo['settBankCode'])) }
                  { renderHeaderValue('Bank Peso Account Number', orderInfo['bankPesoAccountNumber']) }
                  { renderHeaderValue('Statement Delivery Mode', deliveryModesMap(orderInfo['statementDeliveryMode'])) }
                </div>
                <div className={style['slice']}>
                  { renderHeaderValue('Registration of Securities', securityRegistrationMap(orderInfo['securityRegistration'])) }
                  { renderHeaderValue('Name of PDTC Depository Participant', orderInfo['pdtcDepositoryParticipantName']) }
                  { renderHeaderValue('Applicant NoCD/BP ID', orderInfo['applicantNoCDBPID']) }
                  { renderHeaderValue('PDTC Depository Participant BP ID', orderInfo['pdtcDepositoryParticipantBPID']) }
                  { renderHeaderValue('PDTC Depository Participant Omnibus Account No.', orderInfo['pdtcDepositoryParticipantOmnibusAccNo']) }
                </div>
              </div>
              <div className={style['btn-actions']}>
                <Button className="btn-secondary" onClick={()=>nextStep(true)}>BACK</Button>
                <Button onClick={()=>submitHandler()}>
                  {isFormSubmitted ? <Spinner size="sm" animation="border" /> : 'CONFIRM'}
                </Button>
              </div>
            </div>
        </Col>
      </Row>
    </div>
  )
}
export default OrderSummary;
